import { useNavigate } from "flemo";
import { ChevronRightIcon } from "lucide-react";

import { fadeTransition } from "@/lib/transitions";

export function InfoSection() {
  const { push } = useNavigate();

  return (
    <section>
      <div className="rounded-xl bg-card overflow-hidden">
        <SettingsRow label="이용약관" onClick={() => push("/terms", {}, { transitionName: fadeTransition.name })} />
        <SettingsRow
          label="개인정보처리방침"
          onClick={() => push("/privacy", {}, { transitionName: fadeTransition.name })}
        />
      </div>
    </section>
  );
}

function SettingsRow({ label, onClick }: { label: string; onClick: () => void }) {
  return (
    <button
      type="button"
      className="flex w-full items-center justify-between p-4 text-sm font-medium text-foreground hover:bg-muted/50 transition-colors cursor-pointer"
      onClick={onClick}
    >
      {label}
      <ChevronRightIcon className="size-4 text-muted-foreground" />
    </button>
  );
}
